import clsx from 'clsx';
import React from 'react';

import { MaterialIcon } from '#/shared/components/MaterialIcon';

type FormFieldSupportingTextProps = React.PropsWithChildren & {
  leadingIconName?: string;
  isError?: boolean;
  id?: string;
  position?: 'above' | 'below';
  role?: string;
  ariaLive?: 'polite' | 'assertive' | 'off';
};

export function FormFieldSupportingText({
  isError,
  leadingIconName,
  id,
  children,
  position = 'below',
  role,
  ariaLive,
}: FormFieldSupportingTextProps) {
  return (
    <div
      className={clsx(
        'flex gap-4 items-center text-left',
        isError && 'text-error',
        position === 'above' && 'mb-8 -mt-8',
        position === 'below' && 'mt-8',
      )}
      role={role}
      aria-live={ariaLive}
    >
      {leadingIconName && <MaterialIcon iconName={leadingIconName} size={'sm'} aria-hidden="true" />}
      <span id={id} slot={isError ? 'errorMessage' : 'description'} className={clsx('text-14')}>
        {children}
      </span>
    </div>
  );
}
